export const HOURS_BREAKDOWN_COLLAPSED_KEY = 'timeCardHoursBreakdownCollapsed';
export const HIDDEN_STAT_CARDS_KEY = 'timeCardHiddenStatCards';

export const STAT_CARD_KEYS = {
  REGULAR: 'regular',
  OT: 'ot',
  DT_OT: 'dtOt',
  PTO: 'pto',
  TOTAL_HOURS: 'totalHours',
  TOTAL_PAY: 'totalPay',
};

export const STAT_CARD_DEFINITIONS = [
  { key: STAT_CARD_KEYS.REGULAR, label: 'Regular Hours' },
  { key: STAT_CARD_KEYS.OT, label: 'OT Hours' },
  { key: STAT_CARD_KEYS.DT_OT, label: 'DT OT Hours' },
  { key: STAT_CARD_KEYS.PTO, label: 'PTO Hours' },
  { key: STAT_CARD_KEYS.TOTAL_HOURS, label: 'Total Hours' },
  { key: STAT_CARD_KEYS.TOTAL_PAY, label: 'Total Pay' },
];

export const persistHiddenStatCards = (hiddenCards) => {
  if (hiddenCards.size === 0) {
    window.localStorage.removeItem(HIDDEN_STAT_CARDS_KEY);
    return;
  }
  window.localStorage.setItem(
    HIDDEN_STAT_CARDS_KEY,
    JSON.stringify(Array.from(hiddenCards)),
  );
};

export const readStatsCollapsed = () => (
  window.localStorage.getItem(HOURS_BREAKDOWN_COLLAPSED_KEY) === '1'
);

export const readHiddenStatCards = () => {
  try {
    const raw = window.localStorage.getItem(HIDDEN_STAT_CARDS_KEY);
    if (!raw) return new Set();
    const parsed = JSON.parse(raw);
    return new Set(Array.isArray(parsed) ? parsed : []);
  } catch {
    return new Set();
  }
};

export const toNumber = (value) => (Number.isFinite(value) ? value : 0);

export const formatHours = (value) => toNumber(value).toFixed(2);
